import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { HomePageProductProps } from "../../types/ProductList";
import theme from "../../theme/Theme";

const Product: React.FC<HomePageProductProps> = ({
  id,
  name,
  description,
  abv,
  ibu,
  image,
  reverse,
  showBuyButton,
}) => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: reverse ? "row" : "row-reverse",
        alignItems: "center",
        border: "1px solid #000",
        height: "auto",
        marginBottom: 4,
        borderRadius: 0,
        flexWrap: "wrap",
        [theme.breakpoints.down("md")]: {
          flexDirection: "column",
        },
      }}
      data-testid="product-card"
    >
      <CardMedia
        component="img"
        sx={{
          width: "50%",
          height: "100%",
          objectFit: "cover",
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        }}
        image={image}
        alt={name}
      />
      <CardContent
        sx={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 4,
          boxSizing: "border-box",
          [theme.breakpoints.down("md")]: {
            width: "100%",
            padding: "24px",
          },
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            fontWeight: "700",
            textTransform: "none",
            fontFamily: "Poppins, sans-serif",
            color: "#000",
            marginBottom: 1,
          }}
        >
          Our Brews
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            fontFamily: "Poppins, sans-serif",
            color: "#000",
            fontSize: { xs: "22px", sm: "40px" },
          }}
        >
          {name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            color: "#000",
            fontSize: { xs: "12px", sm: "16px" },
            whiteSpace: "normal",
          }}
        >
          {description}
        </Typography>
        <Typography variant="body2">
          IBU:- {ibu} {ibu !== "N/A" && " %"}
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: 2 }}>
          ABV:- {abv} %
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            width: "100%",
            justifyContent: {
              xs: "space-between",
              md: "flex-start",
            },
          }}
        >
          {showBuyButton && (
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderRadius: "16px",
                width: { xs: "91px", sm: "116px", md: "130px" },
                height: { xs: "28px", sm: "48px" },
                fontSize: { xs: "10px", sm: "16px" },
                border: "1px solid black",
              }}
              onClick={() =>
                navigate(`/${orgId}/customer/products/product/${id}`)
              }
            >
              Buy Now
            </Button>
          )}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              color: "#000",
              fontSize: { xs: "14px", sm: "16px", md: "16px" },
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
            onClick={() => navigate(`/${orgId}/customer/products`)}
          >
            Explore Collection <span style={{ marginLeft: "10px" }}>&gt;</span>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Product;
